import { Routes } from '@angular/router';
import { BrightaiShellComponent } from '../layout/shell/brightai-shell.component';
import { authGroupGuard, authGuard } from '@brightside/core/auth';
import { AmplitudeService } from '@brighthub/logging';
import { BrightAiAmplitudeService } from '@brighthub/brightai-logging';
import { BrightAiOmniSearchRegistry } from '@brighthub/brightai-registry';
import { ConversationLayoutComponent } from '../layout/conversation-layout/conversation-layout.component';
import { MyClientsLayoutComponent } from '../layout/my-clients-layout/my-clients-layout.component';
import { environment } from '@brighthub/environment';
import { EmployeeLayoutComponent } from '../layout/employee-layout/employee-layout.component';

/** authGroupGuard group names use environment.environment (dev|stage|prod) and must match Okta group names (e.g. BrightAI_dev_admin). */
export const BrightaiRoutes: Routes = [
  {
    path: 'brightai',
    component: BrightaiShellComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    providers: [
      { provide: AmplitudeService, useClass: BrightAiAmplitudeService },
      BrightAiOmniSearchRegistry,
    ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'myclients',
      },
      {
        path: 'myclients',
        component: MyClientsLayoutComponent,
      },
      {
        path: 'conversation',
        component: ConversationLayoutComponent,
        canMatch: [authGroupGuard([`BrightAI_${environment.environment}_admin`])],
      },
      {
        path: 'conversation/:conversationId',
        component: ConversationLayoutComponent,
        canMatch: [authGroupGuard([`BrightAI_${environment.environment}_admin`])],
      },
      {
        path: 'employee',
        component: EmployeeLayoutComponent,
        canMatch: [authGroupGuard([`BrightAI_${environment.environment}_admin`])],
      },
      {
        path: 'employee/:oktaId',
        component: EmployeeLayoutComponent,
        canMatch: [authGroupGuard([`BrightAI_${environment.environment}_admin`])],
      }
    ],
  },
];
